import React, {useEffect, useState} from "react";
import FlowCard from "../components/FlowCard";
import DownloadABHACard from "../components/DownloadABHACard";
import WorkflowStorage from "../ABDMWorkflowStorage";
import WorkflowStatus from "../components/WorkflowStatus";
const STEPS = {
    SELECT_LOGIN: "SELECT_LOGIN",
    AADHAAR_REQUEST_OTP: "AADHAAR_REQUEST_OTP",
    AADHAAR_VERIFY_OTP: "AADHAAR_VERIFY_OTP",
    ABHA_REQUEST_OTP: "ABHA_REQUEST_OTP",
    ABHA_VERIFY_OTP: "ABHA_VERIFY_OTP",
    MOBILE_REQUEST_OTP: "MOBILE_REQUEST_OTP",
    MOBILE_VERIFY_OTP: "MOBILE_VERIFY_OTP",
    SEARCH_USER: "SEARCH_USER",
    VERIFY_PASSWORD: "VERIFY_PASSWORD",
    VERIFY_USER: "VERIFY_USER",
    PROFILE: "PROFILE", // =========================================================
    // PROFILE MANAGEMENT
    // =========================================================
    PROFILE_MANAGEMENT: "PROFILE_MANAGEMENT",
    SET_PASSWORD_REQUEST_OTP: "SET_PASSWORD_REQUEST_OTP",
    SET_PASSWORD_VERIFY_OTP: "SET_PASSWORD_VERIFY_OTP",
    DOWNLOAD_CARD: "DOWNLOAD_CARD",
    COMPLETE: "COMPLETE"
};
export default function LoginWizard() {
    const [step, setStep] = useState(STEPS.SELECT_LOGIN);
    const [workflow, setWorkflow] = useState({});
    // =========================================================
    // REFRESH WORKFLOW
    // =========================================================
    const refreshWorkflow = () => {
        const data = WorkflowStorage.get();
        console.log("========================================");
        console.log("ABDM WORKFLOW STORAGE");
        console.log(data);
        console.log("========================================");
        setWorkflow(data || {});
    };
    // =========================================================
    // RESTART
    // =========================================================
    const restart = () => {
        WorkflowStorage.clear();
        setWorkflow({});
        setStep(STEPS.SELECT_LOGIN);
    };
    // =========================================================
    // LISTEN WORKFLOW CHANGES
    // =========================================================
    useEffect(() => {
        refreshWorkflow();
        const refresh = () => {
            refreshWorkflow();
        };
        window.addEventListener("workflowChanged", refresh);
        return () => {
            window.removeEventListener("workflowChanged", refresh);
        };
    }, []);
    // =========================================================
    // PROGRESS
    // =========================================================
    const progress = [{
        key: STEPS.SELECT_LOGIN, title: "Login Method"
    }, {
        key: STEPS.AADHAAR_REQUEST_OTP, title: "Aadhaar OTP"
    }, {
        key: STEPS.AADHAAR_VERIFY_OTP, title: "Verify Aadhaar OTP"
    }, {
        key: STEPS.ABHA_REQUEST_OTP, title: "ABHA OTP"
    }, {
        key: STEPS.ABHA_VERIFY_OTP, title: "Verify ABHA OTP"
    }, {
        key: STEPS.MOBILE_REQUEST_OTP, title: "Mobile OTP"
    }, {
        key: STEPS.MOBILE_VERIFY_OTP, title: "Verify Mobile OTP"
    }, {
        key: STEPS.SEARCH_USER, title: "Search User"
    }, {
        key: STEPS.VERIFY_PASSWORD, title: "Password"
    }, {
        key: STEPS.VERIFY_USER, title: "Verify User"
    }, {
        key: STEPS.PROFILE, title: "Profile"
    }, // =====================================================
        // PROFILE MANAGEMENT
        // =====================================================
        {
            key: STEPS.PROFILE_MANAGEMENT, title: "Profile Management"
        }, {
            key: STEPS.SET_PASSWORD_REQUEST_OTP, title: "Password OTP"
        }, {
            key: STEPS.SET_PASSWORD_VERIFY_OTP, title: "Set Password"
        }, {
            key: STEPS.DOWNLOAD_CARD, title: "ABHA Card"
        }, {
            key: STEPS.COMPLETE, title: "Completed"
        }];
    // =========================================================
    // UI
    // =========================================================
    return (<div className="container-fluid">

        <div className="row">

            <div className="col-lg-8">


                {/* =================================================
                        HEADER
                    ================================================= */}

                <div className="d-flex justify-content-between align-items-center mb-4">

                    <div>

                        <h3 className="mb-1">

                            ABHA Login Wizard

                        </h3>

                        <small className="text-muted">

                            Step-by-Step Login Testing

                        </small>

                    </div>


                    <button
                        className="btn btn-outline-danger"
                        onClick={restart}
                    >

                        Restart Wizard

                    </button>

                </div>


                {/* =================================================
                        STEP 1
                        SELECT LOGIN
                    ================================================= */}

                {step === STEPS.SELECT_LOGIN && (<div className="card shadow-sm">

                    <div className="card-header bg-primary text-white">

                        <strong>

                            Select Login Method

                        </strong>

                    </div>


                    <div className="card-body">

                        <div className="row g-3">


                            {/* Aadhaar */}

                            <div className="col-md-6">

                                <button
                                    className="btn btn-outline-primary w-100 p-4"
                                    onClick={() => setStep(STEPS.AADHAAR_REQUEST_OTP)}
                                >

                                    Login using Aadhaar OTP

                                </button>

                            </div>


                            {/* ABHA */}

                            <div className="col-md-6">

                                <button
                                    className="btn btn-outline-success w-100 p-4"
                                    onClick={() => setStep(STEPS.ABHA_REQUEST_OTP)}
                                >

                                    Login using ABHA OTP

                                </button>

                            </div>


                            {/* Mobile */}

                            <div className="col-md-6">

                                <button
                                    className="btn btn-outline-warning w-100 p-4"
                                    onClick={() => setStep(STEPS.MOBILE_REQUEST_OTP)}
                                >

                                    Login using Mobile OTP

                                </button>

                            </div>


                            {/* Search */}

                            <div className="col-md-6">

                                <button
                                    className="btn btn-outline-info w-100 p-4"
                                    onClick={() => setStep(STEPS.SEARCH_USER)}
                                >

                                    Search User

                                </button>

                            </div>


                            {/* Password */}

                            <div className="col-md-12">

                                <button
                                    className="btn btn-outline-dark w-100 p-4"
                                    onClick={() => setStep(STEPS.VERIFY_PASSWORD)}
                                >

                                    Login using Password

                                </button>

                            </div>

                        </div>

                    </div>

                </div>)}


                {/* =================================================
                        STEP 2
                        AADHAAR REQUEST OTP
                    ================================================= */}
                {step === STEPS.AADHAAR_REQUEST_OTP && (
                    <FlowCard

                        title="Login with ABHA Number"

                        endpoint="abdm/abha/login/request-otp-aadhaar/"

                        buttonText="Request OTP"

                        beforeSubmit={() => {
                            WorkflowStorage.clear();
                        }}

                        fields={[
                            {
                                name: "abhaNumber",
                                label: "ABHA Number",
                                required: true,
                            }
                        ]}

                        save={{
                            txnId: "txnId", abhaNumber: "abhaNumber"
                        }}

                        afterSuccess={() => {
                            setStep(STEPS.AADHAAR_VERIFY_OTP);
                        }}

                    />
                )}

                {/* =================================================
                        STEP 3
                        AADHAAR VERIFY OTP
                    ================================================= */}

                {step === STEPS.AADHAAR_VERIFY_OTP && (
                    <FlowCard

                        title="Verify Aadhaar OTP"

                        endpoint="abdm/abha/login/verify-otp-aadhaar/"

                        buttonText="Verify OTP"

                        prefill={{
                            txnId: "txnId"
                        }}

                        requiredWorkflow={[
                            "txnId"
                        ]}

                        fields={[
                            {
                                name: "txnId",
                                hidden: true,
                                readOnly: true
                            },
                            {
                                name: "otp",
                                label: "OTP",
                                required: true,
                                maxLength: 6
                            }
                        ]}

                        save={{
                            tToken: "token",
                            refreshToken: "refreshToken",
                            abhaNumber: "ABHAProfile.ABHANumber"
                        }}

                        afterSuccess={() => {
                            setStep(STEPS.VERIFY_USER);
                        }}

                    />
                )}

                {/* =================================================
                        STEP 4
                        ABHA NUMBER REQUEST OTP
                    ================================================= */}

                {step === STEPS.ABHA_REQUEST_OTP && (<FlowCard

                    title="Request OTP using ABHA Number"

                    description="Enter your ABHA Number. OTP will be sent to the mobile number linked with your ABHA."

                    endpoint="abdm/abha/login/request-otp-abha/"

                    buttonText="Request OTP"

                    beforeSubmit={() => {
                        WorkflowStorage.clear();
                    }}

                    fields={[{
                        name: "abhaNumber", label: "ABHA Number", required: true, placeholder: "Enter ABHA Number"
                    }]}

                    save={{
                        txnId: "txnId", abhaNumber: "abhaNumber"
                    }}

                    afterSuccess={() => {
                        setStep(STEPS.ABHA_VERIFY_OTP);
                    }}

                />)}


                {/* =================================================
                        STEP 5
                        ABHA OTP VERIFY
                    ================================================= */}

                {step === STEPS.ABHA_VERIFY_OTP && (<FlowCard

                    title="Verify ABHA OTP"

                    endpoint="abdm/abha/login/verify-otp-abha/"

                    buttonText="Verify OTP"

                    prefill={{
                        txnId: "txnId"
                    }}

                    requiredWorkflow={["txnId"]}

                    fields={[{
                        name: "txnId", hidden: true, readOnly: true
                    }, {
                        name: "otp", label: "OTP", required: true, maxLength: 6
                    }]}

                    save={{
                        // =====================================================
                        // IMPORTANT
                        // Response "token" is the ABDM T-token
                        // =====================================================
                        tToken: "token", // =====================================================
                        // VERY IMPORTANT
                        // OTP verification returns a NEW txnId.
                        // This MUST overwrite the old txnId.
                        // =====================================================
                        txnId: "txnId", // =====================================================
                        // ABHA NUMBER FROM VERIFIED ACCOUNT
                        // =====================================================
                        abhaNumber: "accounts[0].ABHANumber", // =====================================================
                        // Optional if your later workflow needs it
                        // =====================================================
                        abhaAddress: "accounts[0].preferredAbhaAddress", // =====================================================
                        // Do NOT treat the ABHA OTP response token as
                        // X-token. It is the T-token used for Verify User.
                        // =====================================================
                        refreshToken: "refreshToken"
                    }}

                    afterSuccess={() => {
                        // =====================================================
                        // IMPORTANT:
                        // FlowCard must finish saving the response BEFORE
                        // moving to VERIFY_USER.
                        // =====================================================
                        setStep(STEPS.VERIFY_USER);
                    }}

                />)}


                {/* =================================================
                        STEP 6
                        MOBILE REQUEST OTP
                    ================================================= */}

                {step === STEPS.MOBILE_REQUEST_OTP && (<FlowCard

                    title="Request OTP using Mobile"

                    endpoint="abdm/abha/login/request-otp-mobile/"

                    buttonText="Request Mobile OTP"

                    fields={[{
                        name: "mobile", label: "Mobile Number", required: true
                    }]}

                    save={{
                        txnId: "txnId", mobile: "mobile"
                    }}

                    afterSuccess={() => {
                        setStep(STEPS.MOBILE_VERIFY_OTP);
                    }}

                />)}


                {/* =================================================
                        STEP 7
                        MOBILE VERIFY OTP
                    ================================================= */}

                {step === STEPS.MOBILE_VERIFY_OTP && (<FlowCard

                    title="Verify Mobile OTP"

                    endpoint="abdm/abha/login/verify-mobile-otp/"

                    buttonText="Verify OTP"

                    prefill={{
                        txnId: "txnId"
                    }}

                    requiredWorkflow={["txnId"]}

                    fields={[{
                        name: "txnId", hidden: true, readOnly: true
                    }, {
                        name: "otp", label: "OTP", required: true, maxLength: 6
                    }]}

                    save={{
                        tToken: "token", refreshToken: "refreshToken"
                    }}

                    afterSuccess={() => {
                        setStep(STEPS.SEARCH_USER);
                    }}

                />)}


                {/* =================================================
                        SEARCH USER
                    ================================================= */}

                {step === STEPS.SEARCH_USER && (<FlowCard

                    title="Search User"

                    endpoint="abdm/abha/login/search/"

                    buttonText="Search User"

                    requiredWorkflow={["tToken", "abhaNumber"]}

                    fields={[{
                        name: "ABHANumber", label: "ABHA Number", required: true, placeholder: "Enter ABHA Number"
                    }]}

                    prefill={{
                        ABHANumber: "abhaNumber"
                    }}

                    afterSuccess={() => {
                        setStep(STEPS.VERIFY_PASSWORD);
                    }}

                />)}


                {/* =================================================
                        VERIFY PASSWORD
                    ================================================= */}

                {step === STEPS.VERIFY_PASSWORD && (<FlowCard

                    title="Verify Password"

                    endpoint="abdm/abha/login/verify-password/"

                    buttonText="Verify Password"

                    requiredWorkflow={["abhaNumber"]}

                    prefill={{
                        ABHANumber: "abhaNumber"
                    }}

                    fields={[{
                        name: "ABHANumber", hidden: true, readOnly: true
                    }, {
                        name: "password", label: "Password", type: "password", required: true
                    }]}

                    afterSuccess={() => {
                        setStep(STEPS.VERIFY_USER);
                    }}

                />)}


                {/* =================================================
                        VERIFY USER
                    ================================================= */}
                {step === STEPS.VERIFY_USER && (<FlowCard

                    title="Verify User"

                    endpoint="abdm/abha/login/verify-user/"

                    buttonText="Verify User"

                    requiredWorkflow={["txnId", "abhaNumber", "tToken"]}

                    fields={[]}

                    prefill={{
                        txnId: "txnId", ABHANumber: "abhaNumber", tToken: "tToken"
                    }}

                    save={{
                        xToken: "token",
                        refreshToken: "refreshToken",
                        abhaNumber: "ABHANumber",
                        abhaAddress: "preferredAbhaAddress"
                    }}

                    afterSuccess={() => {
                        setStep(STEPS.PROFILE);
                    }}

                />)}


                {/* =================================================
                        PROFILE
                    ================================================= */}

                {step === STEPS.PROFILE && (<FlowCard

                    title="Get ABHA Profile"

                    endpoint="abdm/get-abha-profile/"

                    method="GET"

                    buttonText="Load Profile"

                    requiredWorkflow={["xToken"]}

                    fields={[]}

                    afterSuccess={() => {
                        setStep(STEPS.PROFILE_MANAGEMENT);
                    }}

                />)}


                {/* =================================================
                        PROFILE MANAGEMENT
                    ================================================= */}

                {step === STEPS.PROFILE_MANAGEMENT && (<div className="card shadow-sm">

                    <div className="card-header bg-success text-white">

                        <strong>

                            Profile Management

                        </strong>

                    </div>


                    <div className="card-body">

                        <p className="text-muted">

                            Manage your ABHA profile and
                            authentication settings.

                        </p>


                        <div className="row g-3">


                            {/* =================================================
                                        SET PASSWORD
                                    ================================================= */}

                            <div className="col-md-12">

                                <div className="border rounded p-4">

                                    <h5 className="mb-2">

                                        Set / Update Password

                                    </h5>

                                    <p className="text-muted mb-3">

                                        Set your ABHA password
                                        using OTP sent to your
                                        registered mobile number.

                                    </p>


                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            setStep(STEPS.SET_PASSWORD_REQUEST_OTP);
                                        }}
                                    >

                                        Set Password

                                    </button>

                                </div>

                            </div>


                            {/* =================================================
                                        FUTURE PROFILE MANAGEMENT
                                    ================================================= */}

                            <div className="col-md-12">

                                <div className="alert alert-info mb-0">

                                    Additional profile management
                                    options can be added here.

                                </div>

                            </div>

                        </div>

                    </div>

                </div>)}


                {/* =================================================
                        SET PASSWORD
                        REQUEST MOBILE OTP
                    ================================================= */}

                {step === STEPS.SET_PASSWORD_REQUEST_OTP && (<FlowCard

                    title="Set Password - Mobile OTP"

                    description="An OTP will be sent to the mobile number registered with your ABHA."

                    endpoint="abdm/abha/profile/set-password/request-otp/"

                    buttonText="Send OTP"

                    requiredWorkflow={["xToken", "abhaNumber"]}

                    prefill={{
                        ABHANumber: "abhaNumber"
                    }}

                    fields={[{
                        name: "ABHANumber", hidden: true, readOnly: true
                    }]}

                    save={{
                        txnId: "txnId"
                    }}

                    afterSuccess={() => {
                        setStep(STEPS.SET_PASSWORD_VERIFY_OTP);
                    }}

                />)}


                {/* =================================================
                        SET PASSWORD
                        VERIFY OTP + NEW PASSWORD
                    ================================================= */}

                {step === STEPS.SET_PASSWORD_VERIFY_OTP && (<FlowCard

                    title="Verify OTP & Set Password"

                    endpoint="abdm/abha/profile/set-password/verify/"

                    buttonText="Set Password"

                    requiredWorkflow={["xToken", "abhaNumber", "txnId"]}

                    prefill={{
                        ABHANumber: "abhaNumber", txnId: "txnId"
                    }}

                    fields={[{
                        name: "ABHANumber", hidden: true, readOnly: true
                    }, {
                        name: "txnId", hidden: true, readOnly: true
                    }, {
                        name: "otp", label: "Mobile OTP", required: true, maxLength: 6
                    }, {
                        name: "password", label: "New Password", type: "password", required: true
                    }, {
                        name: "confirmPassword", label: "Confirm New Password", type: "password", required: true
                    }]}

                    afterSuccess={() => {
                        setStep(STEPS.DOWNLOAD_CARD);
                    }}

                />)}


                {/* =================================================
                        DOWNLOAD CARD
                    ================================================= */}

                {step === STEPS.DOWNLOAD_CARD && (<DownloadABHACard

                    afterSuccess={() => {
                        setStep(STEPS.COMPLETE);
                    }}

                />)}


                {/* =================================================
                        COMPLETE
                    ================================================= */}

                {step === STEPS.COMPLETE && (<div className="card border-success shadow-sm">

                    <div className="card-body text-center p-5">

                        <div
                            className="display-2 mb-3"
                            style={{
                                color: "#16a34a"
                            }}
                        >

                            ✓

                        </div>


                        <h2 className="text-success">

                            Login Workflow Completed

                        </h2>


                        <p className="text-muted mt-3">

                            All login and profile
                            management APIs executed
                            successfully.

                        </p>


                        <button
                            className="btn btn-primary mt-3"
                            onClick={() => {
                                WorkflowStorage.clear();
                                setStep(STEPS.SELECT_LOGIN);
                            }}
                        >

                            Start New Login

                        </button>

                    </div>

                </div>)}

            </div>


            {/* =====================================================
                    RIGHT PANEL
                ===================================================== */}

            <div className="col-lg-4">


                {/* =================================================
                        PROGRESS
                    ================================================= */}

                <div className="card shadow-sm mb-3">

                    <div className="card-header">

                        Progress

                    </div>


                    <div className="card-body">

                        <ul className="list-group">

                            {progress.map(item => (<li
                                key={item.key}
                                className={`list-group-item d-flex justify-content-between align-items-center ${step === item.key ? "active" : ""}`}
                            >

                                {item.title}


                                {step === item.key && (<span className="badge bg-light text-dark">

                                                Current

                                            </span>)}

                            </li>))}

                        </ul>

                    </div>

                </div>


                {/* =================================================
                        WORKFLOW STATUS
                    ================================================= */}

                <WorkflowStatus/>

            </div>

        </div>

    </div>);
}